
import React, { ReactNode } from 'react';
import { useSelector } from 'react-redux';
import * as selector from '../../selectors/selectors';


interface CustomTooltipProps {
    title: string;
    placement?: 'top' | 'bottom' | 'left' | 'right';
    children: ReactNode;
}

const CustomTooltip: React.FC<CustomTooltipProps> = ({ title, placement = 'bottom', children }) => {
    const IsMobileDevice = useSelector(selector.isMobileDevice)
    return (
        <div className={`tooltip-container position-${placement}`}>
            {
                !IsMobileDevice && <div className="tooltip">
                    <span className="tooltip-text">{title}</span>
                </div>
            }
            <div className="icon-container">
                {children}
            </div>
        </div>
    );
};

export default CustomTooltip;
